import { notUndefinedOrNull, PercentageField } from '@hb/shared'
import { CSSProperties, forwardRef, useMemo } from 'react'
import { InputElement, InputProps } from '../../../../../types/fields'
import InputContainer from '../../Shared/InputContainer'
import { useInputSize } from '../../Shared/sizes'
import { TextInputElement } from '../styles'

const inputStyle: CSSProperties = {
  fontFamily: 'monospace',
  fontSize: '16px',
}

const inputSpacerStyle: CSSProperties = {
  ...inputStyle,
  opacity: 0,
  pointerEvents: 'none',
}

const inputPercentStyle: CSSProperties = {
  fontFamily: 'hero-new',
  position: 'relative',
  top: '1px',
  right: '1px',
  fontSize: '15px',
}

const PercentageInput: InputElement<PercentageField> = forwardRef<
  HTMLInputElement,
  InputProps<PercentageField>
>((props, ref) => {
  const { field, input, disabled, readOnly } = props
  const { placeholder, optional } = field
  const { value } = input
  const size = useInputSize(props.size ?? field?.size)
  const isCompact = size === 'xs' || size === 'sm'

  const inputPlaceholder = useMemo(
    () => (optional ? `${placeholder} (percent, optional)` : `${placeholder} (percent)`),
    [placeholder, optional],
  )

  const style = useMemo(
    () => ({
      ...inputStyle,
      fontFamily: value ? 'monospace' : 'inherit',
    }),
    [value],
  )
  return (
    <InputContainer {...props}>
      <TextInputElement
        ref={ref}
        disabled={disabled}
        readOnly={readOnly}
        placeholder={inputPlaceholder}
        {...input}
        onChange={e => {
          input.onChange({
            ...e,
            target: { ...e.target, value: e.target.value.replace(/\D/g, '') },
          })
        }}
        value={(input.value as string).replace(/\D/g, '')}
        style={style}
      />
      {value ? (
        <span
          style={{
            position: 'absolute',
            opacity: notUndefinedOrNull(value) ? 1 : 0,
            display: 'flex',
            alignItems: 'center',
            left: isCompact ? '0.8rem' : '1.2rem',
            pointerEvents: 'none',
            lineHeight: 1,
          }}>
          <span style={inputSpacerStyle}>{input.value.replace(/\D/g, '')}</span>
          <span style={inputPercentStyle}>%</span>
        </span>
      ) : null}
    </InputContainer>
  )
})

export default PercentageInput
